import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";
import "./mandatory.css";

const DocButton = ({ href, label = "PDF" }) => {
  return href ? (
    <a
      className="ma-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open ${label}`}
    >
      <svg viewBox="0 0 24 24" aria-hidden className="ma-icon">
        <path
          d="M12 2v7h7"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M5 22h14a1 1 0 0 0 1-1V6L13 2H6a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      <span>{label}</span>
    </a>
  ) : (
    <button className="ma-btn ma-btn-disabled" disabled aria-disabled="true">
      <svg viewBox="0 0 24 24" aria-hidden className="ma-icon">
        <path
          d="M12 2v7h7"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M5 22h14a1 1 0 0 0 1-1V6L13 2H6a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      <span>PDF</span>
    </button>
  );
};

/* Generic Table Card */
const TableCard = ({ title, columns, rows }) => {
  return (
    <section className="ma-card" aria-labelledby={title.replace(/\s+/g, "-")}>
      <h3 id={title.replace(/\s+/g, "-")} className="ma-card-title">
        {title}
      </h3>
      <div className="ma-table-wrap">
        <table className="ma-table">
          <thead>
            <tr>
              {columns.map((c, idx) => (
                <th key={idx}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rIdx) => (
              <tr key={rIdx}>
                {row.map((cell, cIdx) => (
                  <td key={cIdx} className={cIdx === 0 ? "ma-td-small" : ""}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

const OtherDocument = () => {
  const docsRows = [
    ["1.", "DETAILS OF CURRICULUM", <DocButton href={null} />],
    ["2.", "TRANSFER CERTIFICATE SAMPLE", <DocButton href={null} />],
    ["3.", "NORMS FOLLOWED FOR FIXING FEE", <DocButton href={null} />],
    ["4.", "SELF AFFIDAVIT OF SCHOOL", <DocButton href={null} />],
    ["5.", "DETAILS OF TEACHERS", <DocButton href={null} />],
    ["6.", "WRITTEN DECLARATION ABOUT BOOKS", <DocButton href={null} />],
    ["7.", "BOOK LIST (CLASSWISE AND SUBJECTWISE)", <DocButton href={null} />],
    ["8.", "NUMBER OF STUDENT CLASSWISE", <DocButton href={null} />],
    ["9.", "ANNUAL REPORT", <DocButton href={null} />],
    ["10.", "DETAILS OF TEACHERS TRAINING", <DocButton href={null} />],
    ["11.", "EVENT REPORTS - CLUBS and COMMITTEES", <DocButton href={null} />],
    ["12.", "CIRCULARS", <DocButton href={null} />],
  ];

  return (
    <>
      <RootLayout>
        {/* Animation */}
        <Animation />

        {/* HeaderTwo */}
        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Other Documents"} />
        <section className="about-two py-60 position-relative z-1">
          <div className="position-relative">
            <div className="container">
              <div className="ma-grid container">
                <div className="ma-col-full">
                  <TableCard
                    title="Documents and Information (PDF)"
                    columns={["Sl No", "Documents / Information", "Details"]}
                    rows={docsRows}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default OtherDocument;
